<template>
    <div class="search-box">
            <form>

            <!-- Search Input -->
            <div class="input">   
                    <input type="text" @keyup="updateInputText" @keyup.enter="searchJob" v-model="searchInput.searchTerm" class="form-control search-input" placeholder="Job Title / Key Words">
            </div>   

                    <!-- Filters -->
                    <div class="radios">
                     <div class="accordion form-control">
                        <div class="accordion-item" style="border:0px;">
                            <div class="accordion-header heading-small">
                            <button class="accordion-button"
                             :class="[{ collapsed: !isOpen }, { 'accordion-active-color': isOpen }]"
                             
                             @click.prevent="toggleAccordion">
                                Filters
                            </button>
                        </div>
                            <div class="accordion-collapse collapse"  :class="{ show: isOpen }">
                            <div class="accordion-body">
                                <div class="job-types">
                                    <button v-for="filter in filters" @click.prevent="setFilter(filter)" class="btn btn-default btn-sm job-type-button" :class="filter.isSelected == true ? 'selected' : 'unselected'" >{{filter.jobType}}</button> 
                                </div>
                            </div>
                            </div>
                        </div>
                        </div> 

                    </div>
               
            <!-- location --> 
            
            <div class="selects">
                    <select class="form-select select" @change="updateInputText" v-model="searchInput.location" aria-label="Default select example">
                            <option selected>Select Location</option>
                            <option v-for="district in pagecontent.districts" :value="district">{{ district }}</option>
                    </select>
            </div>
           
            <!-- <div class="search-button"> -->
                <div class="search-buttons">
                    <button type="submit" @click.prevent="searchJob" class="btn btn-default search-button">Search</button>
                    <button v-if="isSearchActived" @click.prevent="cancelSearch" class="btn btn-default btn-sm cancel-button">
                        <CloseIcon/>
                    </button>
                </div>
            <!-- </div> -->
        </form>
    </div>
</template>
<script>

import pagecontent from '@/assets/text.json'
import router from '@/router';
import CloseIcon from './IconComponents/CloseIcon.vue';
export default {
    components:{
        CloseIcon
    },
    data(){
        return{
            pagecontent,
            filters:[],
            isOpen: false,
            selectedFilters:[],
            searchInput:{
                searchTerm:"",
                location:"",
                filters:[]
            },
            isSearchActived: false
        }
    },
    props:{
        externalSearchAsync:{
            type: Function,
            required: false
        },
        searchCancellation:{
            type: Function,
            required: true
        },
        toggleNewProfilesSection:{
            type: Function,
            required: true
        }
    },
    computed:{
        SearchInput(){
            return this.$store.getters["jobs/getSearchInput"] || {};     
        }
    },
    created(){
        pagecontent.jobTypes.forEach(type => {
            this.filters.push({jobType: type, isSelected: false})
        });
    },
    methods: {
        cancelSearch(){
            this.deactivateSearchAndClearFilters();
            this.searchCancellation();
        },
        deactivateSearchAndClearFilters(){
            this.isOpen = false;
            this.isSearchActived = false; //turn off search

            this.searchInput = {
                searchTerm:"",
                location:"",
                filters:[] //clearing filters in store
            },

            this.searchTerm = "";
            this.location = "";
            this.filters = []; //reset displayed filters then reload
            pagecontent.jobTypes.forEach(type => {
            this.filters.push({jobType: type, isSelected: false})
            });
            this.selectedFilters = []; //clear selected filters by user
            //this.searchInput.filters = []//clear filters in store
            this.$store.dispatch('jobs/updateSearchInput', this.searchInput);
        

        },
        getPreviouslySetValues(){
            return this.$store.getters["jobs/getSearchInput"] || {};
        },
        searchJob(){
            this.isOpen = false; //closing accordion
            this.isSearchActived = true;
            if (typeof this.externalSearchAsync === 'function') {
            this.externalSearchAsync();
            }
        },
        toggleAccordion() {
        
        this.isOpen = !this.isOpen
        this.toggleNewProfilesSection();
        },
        setFilter(filter){
            let index = this.filters.findIndex((el) => el == filter);
            if(this.filters[index].isSelected == true){
                this.removeSelectedFilter(filter);
                this.filters[index].isSelected = false;
            }else{
                this.addSelectedFilter(filter);
                this.filters[index].isSelected = true;
            }
           
        },
        addSelectedFilter(filter){
            this.selectedFilters.push(filter);
            this.searchInput.filters = this.selectedFilters.map(filter => filter.jobType);
            this.$store.dispatch('jobs/updateSearchInput', this.searchInput);
        },
        removeSelectedFilter(filter){
            let index = this.selectedFilters.findIndex((el) => el == filter); 
            this.selectedFilters.splice(index, 1); 
            this.searchInput.filters = this.selectedFilters.map(filter => filter.jobType);
            this.$store.dispatch('jobs/updateSearchInput', this.searchInput);
        },
        updateInputText(){
            this.$store.dispatch('jobs/updateSearchInput', this.searchInput);
        },
        
        
  }
}
</script>
<style scoped>

    .cancel-button{
        background-color:var(--input-background);
        color:var(--page-header);
        width:3rem;
    }

    .search-buttons{
        display: flex;
        column-gap:0.8rem;
        
    }

    .search-box{ 
        border-radius: 16px;
        padding:1.2rem;
        margin-top:4.5rem;  
        background: var(--background);
        /** change vertical position of search box */
    }

    form{
        display:grid;
         grid-template-columns: 1fr 1fr; /* 2 columns */
        grid-template-rows: auto auto; /* 2 rows */
        row-gap:1rem;
        column-gap: 1rem;
      
        margin:auto;
      
    }

    /* Row 1, Col 1 → Search input */
.input {
  grid-column: 1;
  grid-row: 1;
}


/* Row 2, Col 1 → Filters accordion */
.radios {
  grid-column: 1;
  grid-row: 2;
   position:relative;
}


    .accordion{
        position: absolute;
        background-color: var(--input-background);
        padding:0.44rem 0.8rem;
    }

    .form-control, .form-select{
        width:20rem;
    }

    .search-button{
        background-color: var(--primary);
        color:white;
        flex:1;
        transition:0.5s;
        grid-column: 2;
        grid-row: 2;
    }

   

    .search-button:hover{
        background-color: var(--primary);
        color:white;
    }

    input{
        background:white!important;
        color:black!important;
    }

    input, select{
        border:0px!important;
    }

    .heading-small{
        grid-column:1/2;
        grid-row:2/3;
        text-transform:uppercase;
        letter-spacing:0.4rem;
        font-size:0.7rem;
        font-weight:bold;
        color:var(--lightgrey3);
    }

 

   
    .accordion-button{
        
        text-transform:uppercase;
        letter-spacing:0.4rem;
        font-size:0.7rem;
        font-weight:bold;
        color:var(--filters-accordion-text);
        padding:0rem;
        margin:0.2rem 0rem;
         background-color: var(--input-background)!important;
         font-weight: 500;
    }

    .accordion-button:focus {
  outline: none;
  box-shadow: none;
}

    



.accordion-button:not(.collapsed) {
  background-color: var(--input-background) !important;
}


.accordion-button::before {
  width: 0.8rem;
  height: 0.8rem;
  background-size: 0.8rem;
  transform: none;
  
}


.accordion-button.collapsed::after {
  width: 0.9rem;
  height: 0.9rem;
  background-size: 0.9rem; 
  transform: none;
}

.accordion-button:not(.collapsed)::after {
  width: 0.8rem;
  height: 0.8rem;
  background-size: 0.8rem;
  transform: none;
}


    
.accordion-item {
  border: none;
  
}

.accordion-collapse{
     background-color: var(--input-background);
}

.accordion-body{
    min-height:13rem;
   background-color: var(--input-background);
}

.form-control{
    border:0px;
}

/* Row 2, Col 2 → Search button */
.search-button {
  grid-column: 2;
  grid-row: 2;
   /* align to the right if you want */
}

/* Row 1, Col 2 → Location select */
.selects {
  grid-column: 2;
  grid-row: 1;
}

.job-types{
    display:flex;
    flex-wrap: wrap;
    gap:0.3rem;
}

.job-type-button{
    border-radius:100px;
    padding:0.15rem 0.8rem;
}

.job-type-button:hover{
    background: var(--primary);
    color:white;
    border:0px;
}



.unselected{
    background:rgb(243, 243, 243);
    border:0px solid var(--primary);
    color:rgb(89, 89, 89);
    
}

.selected{
    border:0px solid var(--primary);
    background:rgba(217, 66, 236, 0.189);
    color:var(--filter-selected);
    font-weight:bold;
    
}

select option:checked {
  background: var(--primary);
  color: white;
}

.accordion-active-color {
  color: var(--filters-accordion-active-color)!important; /* or any color you want */
  background-color:var(--input-background);
}

.search-input{
    background-color:var(--input-background)!important;
    color:var(--foreground)!important;
}




    


    @media(max-width:768px) {

        /* input, selects, radios, search-button */
        form{
            display: flex;
            flex-direction: column;
        }    

        .radios{
            order:3;
            margin-bottom:2rem;
        }

        .selects{
            order:2;
        }

        .search-buttons{
            order:4;
            margin-top:0.2rem;
        }
        
        

         .form-control, .form-select{
        width:10\8rem;
    }

     .search-box{
        margin-bottom:2rem;
        padding:0.7rem; 
     
     
        
    }

    .job-type-button:hover{
        background: none;
        color: inherit;
        border-color: inherit;
    }

    .accordion-button::before {
            width: 0.7rem;
            height: 0.7rem;
            background-size: 0.7rem;
            
            }


        
    
    }
</style>